import { Guid, ITranslations } from "@/types"
import { ArticleType } from "config/constants"

export interface IArticleAssetDto {
    id: Guid
    articleNo: string
    articleType: ArticleType
    assetsAssignedCount: number
    description: string
    descriptionTranslations: ITranslations
    descriptionAdditional?: string
    features?: ITranslations | null
    thumbnailUri?: string
    imageUri?: string
}

export interface IArticleAsset {
    id: Guid
    articleNo: string
    articleType: ArticleType
    assetsAssignedCount: number
    description: string
    descriptionTranslations: ITranslations
    descriptionAdditional?: string
    features?: ITranslations | null
    thumbnailUri?: string
    imageUri?: string
}

export default class ArticleAsset implements IArticleAsset {
    id: Guid
    articleNo: string
    articleType: ArticleType
    assetsAssignedCount: number
    description: string
    descriptionTranslations: ITranslations
    descriptionAdditional?: string
    features?: ITranslations
    thumbnailUri?: string
    imageUri?: string

    constructor(dto: IArticleAssetDto) {
        this.id = dto.id
        this.articleNo = dto.articleNo
        this.articleType = dto.articleType
        this.assetsAssignedCount = dto.assetsAssignedCount
        this.description = dto.description
        this.descriptionTranslations = dto.descriptionTranslations
        this.descriptionAdditional = dto.descriptionAdditional
        this.features = dto.features ?? undefined
        this.thumbnailUri = dto.thumbnailUri
        this.imageUri = dto.imageUri
    }

    static fromDto(dto: IArticleAssetDto): ArticleAsset {
        return new ArticleAsset({
            id: dto.id,
            articleNo: dto.articleNo,
            articleType: dto.articleType,
            assetsAssignedCount: dto.assetsAssignedCount,
            description: dto.description,
            descriptionTranslations: dto.descriptionTranslations,
            descriptionAdditional: dto.descriptionAdditional,
            features: dto.features,
            thumbnailUri: dto.thumbnailUri,
            imageUri: dto.imageUri,
        })
    }
}
